// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.block{
    /* background: #E0EFDE; */
    text-align: left;
    padding: 10px 50px 10px 50px !important;
}

/* .page{
    transform: scale(90%);
} */
.css-1ut7tko{
    width: auto !important;
}
.css-1miwsd9 {
    width: auto !important;
    height: 30%;
    border-radius: 10px;
    background: #fff;
    align-items: center;
    justify-items: right;
    text-align: center;
    padding: 1%;
    display: flex;
    flex-direction: column;
    justify-content: center;
}
.dropdown{
    width: 40% !important;
    height: 35% !important;
    flex-shrink: 0;
    border-radius: 8px !important;
    /* border: 0.5px solid #484848; */
    background: #FFF;
    line-height: 80% !important;

    font-family: 'Verdana', 'Geneva', 'sans-serif' !important;
    font-size: 16px !important;
    font-style: normal;
    font-weight: 400 !important;
    
    /* border-left: 4px solid red; */
    /* border-radius: 4px; */
}

.form-dropdown{
    width: 100% !important;
    height: 45px !important;
    /* height: 35% !important; */
    flex-shrink: 0;
    border-radius: 8px !important;
    /* border: 0.5px solid #484848; */
    background: #FFF;
    line-height: 80% !important;

    font-family: 'Verdana', 'Geneva', 'sans-serif' !important;
    font-size: 16px !important;
    font-style: normal;
    font-weight: 400 !important;
}
.form-dropdown-require{
    font-family: 'Verdana', 'Geneva', 'sans-serif' !important;
    font-size: 16px !important;
    font-style: normal;
    font-weight: 400 !important;
    height: 45px;
}

.form-dropdown-require fieldset{
    border-left: 2px solid red;
    /* height: 11px; */
}
/* To reduce height of select field */
.MuiSelect-select{
    min-height: 1em !important;
}

.dropdown fieldset{
    border-left: 2px solid red;
}

.univ-header{
    width: 100%;
    height: 100%;
    flex-shrink: 0;
    border-bottom: 2px solid #972524;
    background: #FFF;
    box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
}

.container {
    /* height: 60px; */
    padding: 0%;
    transform: scale(90%);
}

.card-action-area{
    height: 46vh;
}

.single-row{
    display: flex;
    color: rgba(0, 0, 0, 0.6);
    font-size: 15px;
}

.card-title{
    font-size: 15px !important;
    font-weight: 600 !important;
    color: rgba(0, 0, 0, 0.6);
    
}

.card-value{
    font-size: 15px !important;
    color: rgba(0, 0, 0, 0.6);
}

@media only screen 
and (max-device-width: 1000px)
{ 
    .container {
        /* height: 60px; */
        padding: 0%;
        transform: scale(98%);
    }
    
}

.sectionBox {
    /* height: 60px; */
    padding: 2% 0% 0% 0%;
    transform: scale(90%);
}

.box .rectangle{
    border: 1px solid #538a30 !important;
    border-radius: 8px;
    height: 100%;
    left: 2%;
    bottom: 1%;
    color: #000;
    /* position: fixed;  */
    /* padding: 20% 20% 20% 20%; */
    width: 95%;
}

.sectionBox .rectangle {
    background-color: #538a30;
    border-radius: 8px;
    height: 100%;
    left: 0;
    color: #FFF;
    /* position: fixed; */
    /* padding: 20% 20% 20% 20%; */
    /* width: 95%; */
}

.formLabel {
    font-size: 16px !important;
    font-weight: 400 !important;
    line-height: 20px !important;
    text-align: left !important;
    margin-top: 0px !important;
    color: #031A1C !important;
    font-family: 'Verdana', 'Geneva', 'sans-serif' !important;
    font-style: normal;
    position: relative !important;
    left: -2% !important;
}

.formInputField input{
    width: 92%;
    height: 11px;
    /* flex-shrink: 0; */
    border-radius: 8px;
    /* border: 0.5px solid #2B4DC0; */
    background: #FFF;
    border-radius: 4px;

    font-family: 'Verdana', 'Geneva', 'sans-serif' !important;
    font-size: 16px !important;
    font-style: normal !important;
    font-weight: 400 !important;
}

.formInputRequired  input{
    width: 92%;
    height: 11px;
    border-radius: 8px;
    background: #FFF;
    border-radius: 4px;
    border-left: 2px solid red;

    font-family: 'Verdana', 'Geneva', 'sans-serif' !important;
    font-size: 16px !important;
    font-style: normal !important;
    font-weight: 400 !important;
}

[role=tooltip].popup-content {
    /* width: 20% !important; */
    width: auto !important
}

[role=presentation].sucess-popup{
    top: -62px !important
}

.popup-content .MuiPaper-root {
    width: 100%;
    
    /* border: 1px solid yellow !important; */
}

.add-more-btn{
    width: 268.516px;
    height: 49px;
    margin-top: 3% !important;
    font-family: 'Verdana', 'Geneva', 'sans-serif';
    font-size: 16px !important;
    font-style: normal;
}

.formTextareaRequired{
    border-left: 2px solid red !important;
    font-family: 'Verdana', 'Geneva', 'sans-serif' !important;
    font-size: 16px !important;
    font-style: normal;
    font-weight: 400 !important;
    line-height: normal;
}

.error-message{
    font-family: 'Verdana', 'Geneva', 'sans-serif' !important;
    font-size: 16px !important;
    font-style: normal;
    font-weight: 400 !important;
    line-height: normal;
    color: red;
}

.additional-button{
    /* width: 156px !important; */
    height: 39px !important;
    flex-shrink: 0 !important;
    border-radius: 8px !important;
    text-transform: none !important;
    text-align: center !important;
    font-family: 'Verdana', 'Geneva', 'sans-serif' !important;
    font-size: 16px !important;
    font-style: normal !important;
    font-weight: 500 !important;
    line-height: 20px !important; /* 142.857% */
}

.MuiStepLabel-iconContainer {
    color: #17aa00 !important;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/form.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;IACzB,gBAAgB;IAChB,uCAAuC;AAC3C;;AAEA;;GAEG;AACH;IACI,sBAAsB;AAC1B;AACA;IACI,sBAAsB;IACtB,WAAW;IACX,mBAAmB;IACnB,gBAAgB;IAIhB,mBAAmB;IACnB,oBAAoB;IACpB,kBAAkB;IAClB,WAAW;IAIX,aAAa;IAGb,sBAAsB;IAItB,uBAAuB;AAC3B;AACA;IACI,qBAAqB;IACrB,sBAAsB;IACtB,cAAc;IACd,6BAA6B;IAC7B,iCAAiC;IACjC,gBAAgB;IAChB,2BAA2B;;IAE3B,yDAAyD;IACzD,0BAA0B;IAC1B,kBAAkB;IAClB,2BAA2B;;IAE3B,gCAAgC;IAChC,wBAAwB;AAC5B;;AAEA;IACI,sBAAsB;IACtB,uBAAuB;IACvB,4BAA4B;IAC5B,cAAc;IACd,6BAA6B;IAC7B,iCAAiC;IACjC,gBAAgB;IAChB,2BAA2B;;IAE3B,yDAAyD;IACzD,0BAA0B;IAC1B,kBAAkB;IAClB,2BAA2B;AAC/B;AACA;IACI,yDAAyD;IACzD,0BAA0B;IAC1B,kBAAkB;IAClB,2BAA2B;IAC3B,YAAY;AAChB;;AAEA;IACI,0BAA0B;IAC1B,kBAAkB;AACtB;AACA,qCAAqC;AACrC;IACI,0BAA0B;AAC9B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,cAAc;IACd,gCAAgC;IAChC,gBAAgB;IAChB,+CAA+C;AACnD;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,qBAAqB;AACzB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,eAAe;AACnB;;AAEA;IACI,0BAA0B;IAC1B,2BAA2B;IAC3B,yBAAyB;;AAE7B;;AAEA;IACI,0BAA0B;IAC1B,yBAAyB;AAC7B;;AAEA;;;IAGI;QACI,kBAAkB;QAClB,WAAW;QACX,qBAAqB;IACzB;;AAEJ;;AAEA;IACI,kBAAkB;IAClB,oBAAoB;IACpB,qBAAqB;AACzB;;AAEA;IACI,oCAAoC;IACpC,kBAAkB;IAClB,YAAY;IACZ,QAAQ;IACR,UAAU;IACV,WAAW;IACX,sBAAsB;IACtB,8BAA8B;IAC9B,UAAU;AACd;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,OAAO;IACP,WAAW;IACX,qBAAqB;IACrB,8BAA8B;IAC9B,gBAAgB;AACpB;;AAEA;IACI,0BAA0B;IAC1B,2BAA2B;IAC3B,4BAA4B;IAC5B,2BAA2B;IAC3B,0BAA0B;IAC1B,yBAAyB;IACzB,yDAAyD;IACzD,kBAAkB;IAClB,6BAA6B;IAC7B,oBAAoB;AACxB;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,oBAAoB;IACpB,kBAAkB;IAClB,iCAAiC;IACjC,gBAAgB;IAChB,kBAAkB;;IAElB,yDAAyD;IACzD,0BAA0B;IAC1B,6BAA6B;IAC7B,2BAA2B;AAC/B;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,0BAA0B;;IAE1B,yDAAyD;IACzD,0BAA0B;IAC1B,6BAA6B;IAC7B,2BAA2B;AAC/B;;AAEA;IACI,2BAA2B;IAC3B;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,WAAW;;IAEX,yCAAyC;AAC7C;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,yBAAyB;IACzB,8CAA8C;IAC9C,0BAA0B;IAC1B,kBAAkB;AACtB;;AAEA;IACI,qCAAqC;IACrC,yDAAyD;IACzD,0BAA0B;IAC1B,kBAAkB;IAClB,2BAA2B;IAC3B,mBAAmB;AACvB;;AAEA;IACI,yDAAyD;IACzD,0BAA0B;IAC1B,kBAAkB;IAClB,2BAA2B;IAC3B,mBAAmB;IACnB,UAAU;AACd;;AAEA;IACI,6BAA6B;IAC7B,uBAAuB;IACvB,yBAAyB;IACzB,6BAA6B;IAC7B,+BAA+B;IAC/B,6BAA6B;IAC7B,yDAAyD;IACzD,0BAA0B;IAC1B,6BAA6B;IAC7B,2BAA2B;IAC3B,4BAA4B,EAAE,aAAa;AAC/C;;AAEA;IACI,yBAAyB;AAC7B","sourcesContent":[".block{\n    /* background: #E0EFDE; */\n    text-align: left;\n    padding: 10px 50px 10px 50px !important;\n}\n\n/* .page{\n    transform: scale(90%);\n} */\n.css-1ut7tko{\n    width: auto !important;\n}\n.css-1miwsd9 {\n    width: auto !important;\n    height: 30%;\n    border-radius: 10px;\n    background: #fff;\n    -webkit-align-items: center;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n    justify-items: right;\n    text-align: center;\n    padding: 1%;\n    display: -webkit-box;\n    display: -webkit-flex;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-flex-direction: column;\n    -ms-flex-direction: column;\n    flex-direction: column;\n    -webkit-box-pack: center;\n    -ms-flex-pack: center;\n    -webkit-justify-content: center;\n    justify-content: center;\n}\n.dropdown{\n    width: 40% !important;\n    height: 35% !important;\n    flex-shrink: 0;\n    border-radius: 8px !important;\n    /* border: 0.5px solid #484848; */\n    background: #FFF;\n    line-height: 80% !important;\n\n    font-family: 'Verdana', 'Geneva', 'sans-serif' !important;\n    font-size: 16px !important;\n    font-style: normal;\n    font-weight: 400 !important;\n    \n    /* border-left: 4px solid red; */\n    /* border-radius: 4px; */\n}\n\n.form-dropdown{\n    width: 100% !important;\n    height: 45px !important;\n    /* height: 35% !important; */\n    flex-shrink: 0;\n    border-radius: 8px !important;\n    /* border: 0.5px solid #484848; */\n    background: #FFF;\n    line-height: 80% !important;\n\n    font-family: 'Verdana', 'Geneva', 'sans-serif' !important;\n    font-size: 16px !important;\n    font-style: normal;\n    font-weight: 400 !important;\n}\n.form-dropdown-require{\n    font-family: 'Verdana', 'Geneva', 'sans-serif' !important;\n    font-size: 16px !important;\n    font-style: normal;\n    font-weight: 400 !important;\n    height: 45px;\n}\n\n.form-dropdown-require fieldset{\n    border-left: 2px solid red;\n    /* height: 11px; */\n}\n/* To reduce height of select field */\n.MuiSelect-select{\n    min-height: 1em !important;\n}\n\n.dropdown fieldset{\n    border-left: 2px solid red;\n}\n\n.univ-header{\n    width: 100%;\n    height: 100%;\n    flex-shrink: 0;\n    border-bottom: 2px solid #972524;\n    background: #FFF;\n    box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);\n}\n\n.container {\n    /* height: 60px; */\n    padding: 0%;\n    transform: scale(90%);\n}\n\n.card-action-area{\n    height: 46vh;\n}\n\n.single-row{\n    display: flex;\n    color: rgba(0, 0, 0, 0.6);\n    font-size: 15px;\n}\n\n.card-title{\n    font-size: 15px !important;\n    font-weight: 600 !important;\n    color: rgba(0, 0, 0, 0.6);\n    \n}\n\n.card-value{\n    font-size: 15px !important;\n    color: rgba(0, 0, 0, 0.6);\n}\n\n@media only screen \nand (max-device-width: 1000px)\n{ \n    .container {\n        /* height: 60px; */\n        padding: 0%;\n        transform: scale(98%);\n    }\n    \n}\n\n.sectionBox {\n    /* height: 60px; */\n    padding: 2% 0% 0% 0%;\n    transform: scale(90%);\n}\n\n.box .rectangle{\n    border: 1px solid #538a30 !important;\n    border-radius: 8px;\n    height: 100%;\n    left: 2%;\n    bottom: 1%;\n    color: #000;\n    /* position: fixed;  */\n    /* padding: 20% 20% 20% 20%; */\n    width: 95%;\n}\n\n.sectionBox .rectangle {\n    background-color: #538a30;\n    border-radius: 8px;\n    height: 100%;\n    left: 0;\n    color: #FFF;\n    /* position: fixed; */\n    /* padding: 20% 20% 20% 20%; */\n    /* width: 95%; */\n}\n\n.formLabel {\n    font-size: 16px !important;\n    font-weight: 400 !important;\n    line-height: 20px !important;\n    text-align: left !important;\n    margin-top: 0px !important;\n    color: #031A1C !important;\n    font-family: 'Verdana', 'Geneva', 'sans-serif' !important;\n    font-style: normal;\n    position: relative !important;\n    left: -2% !important;\n}\n\n.formInputField input{\n    width: 92%;\n    height: 11px;\n    /* flex-shrink: 0; */\n    border-radius: 8px;\n    /* border: 0.5px solid #2B4DC0; */\n    background: #FFF;\n    border-radius: 4px;\n\n    font-family: 'Verdana', 'Geneva', 'sans-serif' !important;\n    font-size: 16px !important;\n    font-style: normal !important;\n    font-weight: 400 !important;\n}\n\n.formInputRequired  input{\n    width: 92%;\n    height: 11px;\n    border-radius: 8px;\n    background: #FFF;\n    border-radius: 4px;\n    border-left: 2px solid red;\n\n    font-family: 'Verdana', 'Geneva', 'sans-serif' !important;\n    font-size: 16px !important;\n    font-style: normal !important;\n    font-weight: 400 !important;\n}\n\n[role=tooltip].popup-content {\n    /* width: 20% !important; */\n    width: auto !important\n}\n\n[role=presentation].sucess-popup{\n    top: -62px !important\n}\n\n.popup-content .MuiPaper-root {\n    width: 100%;\n    \n    /* border: 1px solid yellow !important; */\n}\n\n.add-more-btn{\n    width: 268.516px;\n    height: 49px;\n    margin-top: 3% !important;\n    font-family: 'Verdana', 'Geneva', 'sans-serif';\n    font-size: 16px !important;\n    font-style: normal;\n}\n\n.formTextareaRequired{\n    border-left: 2px solid red !important;\n    font-family: 'Verdana', 'Geneva', 'sans-serif' !important;\n    font-size: 16px !important;\n    font-style: normal;\n    font-weight: 400 !important;\n    line-height: normal;\n}\n\n.error-message{\n    font-family: 'Verdana', 'Geneva', 'sans-serif' !important;\n    font-size: 16px !important;\n    font-style: normal;\n    font-weight: 400 !important;\n    line-height: normal;\n    color: red;\n}\n\n.additional-button{\n    /* width: 156px !important; */\n    height: 39px !important;\n    flex-shrink: 0 !important;\n    border-radius: 8px !important;\n    text-transform: none !important;\n    text-align: center !important;\n    font-family: 'Verdana', 'Geneva', 'sans-serif' !important;\n    font-size: 16px !important;\n    font-style: normal !important;\n    font-weight: 500 !important;\n    line-height: 20px !important; /* 142.857% */\n}\n\n.MuiStepLabel-iconContainer {\n    color: #17aa00 !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
